<script>
	import IssueTab from "./IssueTab.svelte";

	export let detailData;

	let reportSection = "Exterior";
</script>

<IssueTab {reportSection} {detailData} />
